import { ref } from "vue";

/** ダイアログ・オーバーレイの表示状態を扱う composable。 */
export const useDeliveryMoveRegisterUiState = () => {
  const errdialog = ref(false);
  const errMessage = ref("");
  const overlay = ref(false);
  // 確認・完了ダイアログ関連
  const displayConfirmDialog = ref(false);
  const displayCompletedDialog = ref(false);

  return {
    errdialog,
    errMessage,
    overlay,
    displayConfirmDialog,
    displayCompletedDialog,
  };
};
